export default {
  'channelDistributor.title': 'Distribuidores',
  'channelDistributor.description':
    'Registra y mantiene distribuidores vinculados a datos de empresa.',

  'channelDistributor.columns.identity': 'Identidad',
  'channelDistributor.columns.shortCode': 'Código corto',
  'channelDistributor.columns.country': 'País',
  'channelDistributor.columns.agreementId': 'Acuerdo comercial',
  'channelDistributor.columns.canCreatePartners': 'Puede crear partners',
  'channelDistributor.columns.canCreateResellers': 'Puede crear revendedores',
  'channelDistributor.columns.partnerAgreementMode': 'Modo acuerdo partner',
  'channelDistributor.columns.defaultPartnerAgreementId': 'Acuerdo partner por defecto',
  'channelDistributor.columns.defaultResellerAgreementId': 'Acuerdo revendedor por defecto',

  'distributorPartnerAgreementMode.automyManaged': 'Gestionado por Automy',
  'distributorPartnerAgreementMode.distributorManaged': 'Gestionado por distribuidor',
};
